
import RcDomainObject from '@/domain/common/RcDomainObject.js';

export default class RcError extends RcDomainObject {
  
  static Fields = {
      MessageId: "messageId",
      Hint: "hint",
  }
  
  static Values = {
      MessageIds: {
        InvoiceAlreadyPaid: "InvoiceAlreadyPaidId", 
        // A checklist save that kept the edit but could not record its frozen version.
        ChecklistVersionNotSaved: "ChecklistVersionNotSavedId",
        // A save refused because it would change a built-in checklist (HTTP 403).
        ChecklistBuiltInLocked: "ChecklistBuiltInLockedId",
        ChecklistNoteLocked: "ChecklistNoteLockedId",
        ChecklistNeedsCompany: "ChecklistNeedsCompanyId",
        ChecklistItemLocked: "ChecklistItemLockedId",
        ChecklistOtherCompany: "ChecklistOtherCompanyId",
      },
  }
  
  constructor(domain, data) {
    super(domain, data);
  }
  
  messageId() {
    return this.getString(RcError.Fields.MessageId);
  }

  withMessageId(messageId) {
    this.put(RcError.Fields.MessageId, messageId);
    return this;
  }

  hint() {
    return this.getString(RcError.Fields.Hint);
  }
  
  withHint(hint) {
    this.put(RcError.Fields.Hint, hint);
    return this;
  }
  
  isInvoiceAlreadyPaid() {
    var messageId = this.getString(RcError.Fields.MessageId);
    return RcError.Values.MessageIds.InvoiceAlreadyPaid == messageId; 
  }

  isChecklistVersionNotSaved() {
    return RcError.Values.MessageIds.ChecklistVersionNotSaved == this.messageId();
  }

  isChecklistBuiltInLocked() {
    return RcError.Values.MessageIds.ChecklistBuiltInLocked == this.messageId();
  }

  isChecklistNoteLocked() {
    return RcError.Values.MessageIds.ChecklistNoteLocked == this.messageId();
  }

  isChecklistNeedsCompany() {
    return RcError.Values.MessageIds.ChecklistNeedsCompany == this.messageId();
  }

  isChecklistItemLocked() {
    return RcError.Values.MessageIds.ChecklistItemLocked == this.messageId();
  }

  isChecklistOtherCompany() {
    return RcError.Values.MessageIds.ChecklistOtherCompany == this.messageId();
  }
}
